import { Link } from '@inertiajs/react'
import { FileText, Upload } from 'lucide-react'
import { download_template_salesminer_admin_organization_uploads_path } from '@/routes'

export default function HeaderActions() {
    return (
        <div className="flex items-center space-x-3">
            <a
                href={download_template_salesminer_admin_organization_uploads_path()}
                className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded text-sm font-medium transition-colors inline-flex items-center"
            >
                <FileText className="w-4 h-4 mr-2"/>
                Download Template
            </a>
            <Link
                href="/admin/organization_uploads/new"
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded text-sm font-medium transition-colors inline-flex items-center"
            >
                <Upload className="w-4 h-4 mr-2"/>
                New Upload
            </Link>
        </div>
    )
}